import { CredentialsKeyEnum } from '../../../types';
export const secureCredentials = [
    CredentialsKeyEnum.ApiKey,
    CredentialsKeyEnum.ApiToken,
    CredentialsKeyEnum.SecretKey,
    CredentialsKeyEnum.Token,
    CredentialsKeyEnum.Password,
    CredentialsKeyEnum.ServiceAccount,
];
//# sourceMappingURL=secure-credentials.js.map